module.exports = __webpack_public_path__ + "static/media/crossed-eye.51520e6f.svg";